module.exports = __webpack_public_path__ + "img/自媒v发布.ea74d8eb.png";